/**
 * Shared kill switch for every analytics sink: local development never sends.
 *
 * The guard lives in its own module because each sink has its OWN opt-back-in flag
 * (`VITE_SEGMENT_DEBUG` for Segment, `VITE_USAGE_DEBUG` for the first-party usage sink) but they
 * must agree on what counts as a local host. Callers pass their flag; the host list is one copy.
 */
export function isBlockedHost(debugFlag: unknown): boolean {
  if (typeof window === 'undefined') return true;
  if (`${debugFlag}` === 'true') return false;
  const { hostname } = window.location;
  // The WHOLE 127.0.0.0/8 range, not just 127.0.0.1 — an app served at 127.0.0.2 is equally local,
  // and this guard is the only thing standing between a dev machine and three live sinks.
  // IPv6 loopback included: URL hostname keeps the brackets, but both spellings are cheap.
  return ['localhost', '[::1]', '::1'].includes(hostname) || hostname.startsWith('127.');
}
